import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const createKey = () => ['massActionsRequestStages'];

const fetch = () =>
  request.get(
    `FlatsGrid/stage_address_life_cycle`,
    {},
    `Произошла ошибка при загрузке стадий ЖЦ`,
  );

const useFetch = (options) => useQuery(createKey(), fetch, options);

const queryData = { createKey, useFetch };

export default queryData;
